import React from 'react'
import PropTypes from 'prop-types'
import Image from 'next/image'
import FilterGroup from 'components/FilterGroup'
import styles from './styles'

const HeaderWithFilters = ({ onSearch, filters, loading, filtersSelected }) => {
  return (
    <div className={`header-container ${styles.backgroundContainer}`}>
      <div className={`flex-container ${styles.flexContainer}`} id="candidates">
        <div className={`header-text ${styles.headerText}`}>
          <h1 className={`title ${styles.title}`}>
            Find <span className={styles.hyperlinkText}>real</span> software developers across Europe and Africa
          </h1>
        </div>
        <div className={`${styles.desktopHeaderImageContainer}`}>
          <Image
            src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/header-with-filters.png`}
            alt="Discover job-seeking developers across Europe and Africa"
            width={430}
            height={110}
            priority
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </div>
        <div className={`${styles.mobileHeaderImageContainer}`}>
          <Image
            src={`${process.env.NEXT_PUBLIC_BASEPATH}/assets/candidates.png`}
            alt="Discover job-seeking developers across Europe and Africa"
            width={320}
            height={127}
            style={{
              maxWidth: '100%',
              height: 'auto',
            }}
          />
        </div>
      </div>
      <div className={styles.filtersContainer}>
        <div className={styles.filtersWhiteBackground}>
          <FilterGroup filtersSelected={filtersSelected} filters={filters} onSearch={onSearch} loading={loading} />
        </div>
      </div>
    </div>
  )
}

HeaderWithFilters.propTypes = {
  filters: PropTypes.object,
  onSearch: PropTypes.func,
  loading: PropTypes.bool,
  filtersSelected: PropTypes.object,
}

export default HeaderWithFilters
